<script setup lang="ts">
import type { PostRow } from '@/types/interface'
const props = defineProps({
  item: null,
  playable: { type: Boolean },
  isFull: { type: Boolean },
  postWidth: null,
  layout: null,
  isIM: { type: Boolean }
})
const { t } = useI18n()
const { needMask, isFree, isDfans } = usePost()
const videoHeight = ref<number | null>(null)

const current: any = ref(props.item.media![0])
const videoRef = ref()
const isPlaying = ref(false)
const isMob = isMobile()
const isIM = computed(() => {
  return props.isIM
})

function init() {
  current.value = props.item.media![0]
}
function play() {
  isPlaying.value = true
  nextTick(() => {
    setTimeout(() => {
      videoRef.value && videoRef.value.play()
    }, 200)
  })
}

function handleStopVideoPlay() {
  isPlaying.value = false
}

const handleImageLoad = (e: any) => {
  // e.height 因渲染速度得到不确定值，改为计算
  const width = isMobile() ? document.body.clientWidth : 600
  videoHeight.value = Math.floor((e.naturalHeight * width) / e.naturalWidth)
}

watch(props, () => {
  init()
})
onMounted(init)
</script>

<template>
  <div class="relative overflow-hidden Operate flex items-center justify-center w-full">
    <div class="relative z-1 flex items-center justify-center w-full">
      <div
        v-show="isPlaying"
        class="w-full min-h-max flex items-center justify-center"
        :style="videoHeight ? { height: `${videoHeight}px` } : { height: '600px' }"
      >
        <VideoPlayer
          ref="videoRef"
          :url="current?.url"
          :cover="current?.cover"
          custom-play-button
          @stop="handleStopVideoPlay"
        />
      </div>
      <lockView :layout="layout" :item="item" transparent inline class="absolute z-10" />
      <div v-show="!isPlaying" class="w-full h-full relative z-1 flex items-center justify-center">
        <DefaultImg
          v-if="current.cover"
          img-type="original"
          :class="`${isDfans(item) || (isFree(item) && !needMask(item)) || isIM ? '' : ' blur-20px sm:max-h-84.5 imgBox'} ${isIM ? 'h-full' : 'w-full'} block`"
          object-fit="cover"
          preview-disabled
          :src="current.cover"
          :on-load="handleImageLoad"
        />
        <div v-else class="sm:h-100 w-full h-62.5 relative">
          <img src="@/assets/image/post/bg.webp" class="w-full absolute top-0 left-0" alt="dfans" />
        </div>
        <postMask v-if="!isIM" :item="item" @viewHandle="play" />
        <n-tooltip>
          <template #trigger>
            <div class="absolute-center w-16 h-16">
              <div
                v-if="isDfans(item) || (isFree(item) && !needMask(item)) || isIM"
                @click="play()"
              >
                <img
                  src="@/assets/image/player/play.webp"
                  class="w-15 h-15 absolute-center cursor-pointer"
                  :class="{ 'cursor-pointer': playable, OperateImg1: !isMob }"
                  alt="dfans"
                />
                <img
                  src="@/assets/image/player/play-active.webp"
                  class="w-15 h-15 absolute-center hidden cursor-pointer"
                  :class="{ OperateImg2: !isMob }"
                  alt="dfans"
                />
              </div>
            </div>
          </template>
          <span class="tooltip">{{ t('PlayVideo') }}</span>
        </n-tooltip>
      </div>
    </div>
  </div>
</template>

<style scoped lang="less">
@media screen and (max-width: 640px) {
  .imgBox {
    max-height: calc(100dvw / 1.769);
  }
}
</style>
